import React, { Component } from "react";
import PropTypes from 'prop-types';


import markerClosedImg from "../../img/Marker-closed.svg";
import markerOpenImg from "../../img/Marker-open.svg";


export class Graphics extends Component {
  componentWillMount() {
  }

  render (){
  console.log('rending markerjs graphics', this.props);

    const markerImg = this.props.open ? markerOpenImg : markerClosedImg
    return(
      <img
      width="100"
      aria-label="Agarose Gel"
      alt="Agarose Gel"
      aria-hidden={this.props.context==="Materials"?"true":"false"}
      className={this.props.type+"-gel gel"}
      src={markerImg}/>
    )
  }
}
Graphics.propTypes = {
  setGelHeld: PropTypes.func,
}

Graphics.defaultProps = {

}